import { makeRequest } from "../request";
import {
  getRichiesteEndpoint,
  getRichiestaEndpoint,
  getVassoioItemEndpoint,
  putVassoioItemEndpoint,
} from "../endpoint";

export const getRichieste = async () => {
  return await makeRequest("GET", getRichiesteEndpoint(), true);
};

export const getRichiesta = async (idRichiesta) => {
  return await makeRequest("GET", getRichiestaEndpoint(idRichiesta), true);
};

export const getVassoioItem = async (idRichiesta, idVassoioItem, idPortata) => {
  return await makeRequest(
    "GET",
    getVassoioItemEndpoint(idRichiesta, idVassoioItem, idPortata),
    true
  );
};

export const updatePortata = async (
  idRichiesta,
  idVassoioItem,
  idPortata,
  portata
) => {
  return await makeRequest(
    "PUT",
    putVassoioItemEndpoint(idRichiesta, idVassoioItem, idPortata),
    true,
    portata
  );
};
